import { Router } from '@angular/router';
import { BaseComponent } from 'app/base/base.component';
import { Merchant } from 'app/core/models/merchant';
import { Supplier } from 'app/core/models/supplier';
import { MerchantService } from 'app/core/services/merchant.service';
import { SupplierService } from 'app/core/services/supplier.service';
import { NGXLogger } from 'ngx-logger';
import { Observable, of as observableOf, of, Subscription } from 'rxjs';
import { map, tap, take, publishReplay, refCount } from 'rxjs/operators';
import { PointOfService } from '../models/pointOfService';
import { PosService } from '../services/pos.service';


export abstract class AbstractMerchantSupplierComponent extends BaseComponent {

    // TODO to remove
    // Used in the select components for event searches
    // To be removed when new select components are used
    public allSuppliersArray: Supplier[] = [];


    public merchantObservables: Map<number, Observable<Merchant>> = new Map<number, Observable<Merchant>>();
    public supplierObservables: Map<number, Observable<Supplier>> = new Map<number, Observable<Supplier>>();
    public posObservables: Map<number, Observable<PointOfService>> = new Map<number, Observable<PointOfService>>();

    // We have to cache every observable to avoid angular async pipe to loop
    public supplierNameObservables: Map<number, Observable<string>> = new Map<number, Observable<string>>();
    public merchantNameObservables: Map<number, Observable<string>> = new Map<number, Observable<string>>();
    public merchantDeletedObservables: Map<number, Observable<string>> = new Map<number, Observable<string>>();
    public merchantDeletedDateObservables: Map<number, Observable<string>> = new Map<number, Observable<string>>();
    public posNameObservables: Map<number, Observable<string>> = new Map<number, Observable<string>>();

    // TODO to remove
    // Used in the select components for event searches
    // To be removed when new select components are used
    public allMerchantsArray: Merchant[] = [];

    public nameNotFoundObs: Observable<string> = observableOf("N/A");
    public deletedNotFoundObs: Observable<string> = observableOf("N/A");

    supplierSub: Subscription;
    merchantSub: Subscription;
    posSub: Subscription;

    constructor(
        protected supplierService: SupplierService,
        protected merchantService: MerchantService,
        protected posService: PosService,
        protected log: NGXLogger,
        public router: Router
    ) { super(router); }

    private getMerchantAndCache(id: number): Observable<Merchant> {
        if (this.merchantObservables.has(id)) {
            return this.merchantObservables.get(id);
        } else {
            let obs = this.merchantService.getMerchantById(id).pipe(take(1));
            this.merchantObservables.set(id, obs);
            return obs;
        }
    }
    private getSupplierAndCache(id: number): Observable<Supplier> {
        if (this.supplierObservables.has(id)) {
            return this.supplierObservables.get(id);
        } else {
            let obs = this.supplierService.getSupplierById(id).pipe(take(1));
            this.supplierObservables.set(id, obs);
            return obs;

        }
    }

    public getSupplierName(id: number): Observable<string> {
        if (id) {
            if (this.supplierNameObservables.has(id)) {
                return this.supplierNameObservables.get(id);
            } else {
                let res = this.getSupplierAndCache(id).pipe(map(s => s.name));
                this.supplierNameObservables.set(id, res);
                return res;
            }
        } else {
            return this.nameNotFoundObs;
        }
    }

    public getMerchantName(id: number): Observable<string> {
        if (id) {
            if (this.merchantNameObservables.has(id)) {
                return this.merchantNameObservables.get(id);
            } else {
                let res = this.getMerchantAndCache(id).pipe(map(s => s.name));
                this.merchantNameObservables.set(id, res);
                return res;
            }
        } else {
            return this.nameNotFoundObs;
        }
    }

    public getMerchantDeleted(id: number): Observable<string> {
        if (id) {
            if (this.merchantNameObservables.has(id)) {
                return this.merchantNameObservables.get(id);
            } else {
                let res = this.getMerchantAndCache(id).pipe(map(s => s.deleted));
                this.merchantNameObservables.set(id, res);
                return res;
            }
        } else {
            return this.deletedNotFoundObs;
        }
    }

    public getMerchantDeletedDate(id: number): Observable<string> {
        if (id) {
            if (this.merchantNameObservables.has(id)) {
                return this.merchantNameObservables.get(id);
            } else {
                let res = this.getMerchantAndCache(id).pipe(map(s => s.logicalDeletionDate));
                this.merchantNameObservables.set(id, res);
                return res;
            }
        } else {
            return this.deletedNotFoundObs;
        }
    }

    getSuppliers() {
        this.supplierSub = this.supplierService.getAllSuppliers().subscribe(suppliers => {
            this.allSuppliersArray = suppliers.content;
            this.allSuppliersArray.sort((a, b) => a.name.localeCompare(b.name));
            this.allSuppliersArray.forEach(sup => {
                this.supplierObservables.set(sup.id, observableOf(sup));
            });
        });
    }

    getMerchants() {
        this.merchantSub = this.merchantService.getAllMerchants().subscribe(merchants => {
            this.allMerchantsArray = merchants.content;
            this.allMerchantsArray.sort((a, b) => a.name.localeCompare(b.name));
            this.allMerchantsArray.forEach(merchant => {
                this.merchantObservables.set(merchant.id, observableOf(merchant));
            });
        });
    }

    public closeSubscribtions(): void {
        if (this.merchantSub) {
            this.merchantSub.unsubscribe();
        }
        if (this.supplierSub) {
            this.supplierSub.unsubscribe();
        }
        if (this.posSub) {
            this.posSub.unsubscribe();
        }
    }
}
